<template>
	<svg
		:width="iconSize"
		:height="iconSize"
		viewBox="0 0 25 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M9.5 11.75H13.25M9.5 14.75H13.25M9.5 17.75H13.25M16.25 18.5H18.5C19.7426 18.5 20.75 17.4926 20.75 16.25V5.85822C20.75 4.72324 19.905 3.76015 18.7739 3.66627C18.4006 3.63529 18.0261 3.60858 17.6505 3.58619M11.8495 3.58619C11.7848 3.79602 11.75 4.01894 11.75 4.25C11.75 4.66421 12.0858 5 12.5 5H17C17.4142 5 17.75 4.66421 17.75 4.25C17.75 4.01894 17.7152 3.79602 17.6505 3.58619M11.8495 3.58619C12.1328 2.66757 12.9884 2 14 2H15.5C16.5116 2 17.3672 2.66757 17.6505 3.58619M11.8495 3.58619C11.4739 3.60858 11.0994 3.63529 10.7261 3.66627C9.59499 3.76015 8.75 4.72324 8.75 5.85822V8M8.75 8H5.375C4.75368 8 4.25 8.50368 4.25 9.125V20.375C4.25 20.9963 4.75368 21.5 5.375 21.5H15.125C15.7463 21.5 16.25 20.9963 16.25 20.375V9.125C16.25 8.50368 15.7463 8 15.125 8H8.75ZM7.25 11.75H7.2575V11.7575H7.25V11.75ZM7.25 14.75H7.2575V14.7575H7.25V14.75ZM7.25 17.75H7.2575V17.7575H7.25V17.75Z"
			:stroke="color"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconSvgClipboardList',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
		isActive: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style></style>
